var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"void-img-wrapper"},[_c('img',{staticClass:"void-img",attrs:{"src":_vm.imageUrl}}),_vm._t("default",[_c('div',{staticClass:"void-text mt-12"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }